import React from "react"
import {
  Route,
  Switch,
  useRouteMatch,
} from "react-router-dom"
import useModal from "services/useModal"
import { ModalName } from "sharedTypes"

import BadgeTemplateEdit from "./BadgeTemplateEdit"
import BadgeTemplates from "./BadgesTemplates"

type Props = {
  eventId: string
}

const Badges = ({ eventId }: Props) => {
  const { path } = useRouteMatch()
  const showModal = useModal()

  const handleCreateNew = () => {
    showModal(ModalName.BadgeTemplateBrowser)
  }

  return (
    <Switch>
      <Route path={`${path}/:templateId/edit`}>
        <BadgeTemplateEdit />
      </Route>
      <Route path={`${path}`}>
        <BadgeTemplates
          eventId={eventId}
          onCreateNew={handleCreateNew}
        />
      </Route>
    </Switch>
  )
}

export default Badges
